module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-11-7095be3454161254181189116a8e90da.webp";